import { render, staticRenderFns } from "./create-shipment-form.vue?vue&type=template&id=f3fcb62a&"
import script from "./create-shipment-form.vue?vue&type=script&lang=js&"
export * from "./create-shipment-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports